export default "__VITE_ASSET__402c5c10__"